// src/Routes.tsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Createuser from './components/adminpanel/createuser';
import UserLogin from './components/adminpanel/userlogin';
// import Home from './components/landingpage/home';
import DataForm from './components/landingpage/home';
import ClientDataPage from './components/landingpage/ClientDataPage';
import TodoApp from './components/landingpage/todo';
import AccountsPage from './components/landingpage/accounts';
// import WeddingGallery from './components/weddingGallery/weddingGallery';


const AppRoutes: React.FC = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<DataForm />} />
                {/* Route for user creation */}
                <Route path="/createuser" element={<Createuser />} />
                {/* Route for user login */}
                <Route path="/login" element={<UserLogin />} />
                <Route path="/Clientdata" element={<ClientDataPage />} />
                <Route path="/AccountsPage" element={<AccountsPage />} />
                <Route path="/accounts" element={<AccountsPage />} />
                <Route path="/TodoApp" element={<TodoApp />} />
                {/* <Route path="/WeddingGallery" element={<WeddingGallery />} /> */}

            </Routes>
        </Router>
    );
};

export default AppRoutes;
